import { useEffect, useState } from "react";

/**
 * A React hook that manages object URLs with automatic cleanup.
 *
 * @example
 * ```tsx
 * const MyComponent = ({ file }) => {
 *   const objectUrl = useObjectUrl(file);
 *   return objectUrl ? <img src={objectUrl} alt="Preview" /> : null;
 * };
 * ```
 */
export function useObjectUrl(obj: Blob | null | undefined): string | null {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    const url = obj ? URL.createObjectURL(obj) : null;
    setObjectUrl(url);
    if (url) return () => URL.revokeObjectURL(url);
  }, [obj]);

  return objectUrl;
}
